import React from "react";
import SystemPage from "pages/Admin/Settings/SystemPage";
import CriteriaService from "services/Admin/CriteriaService";

const CriteriasPage = (props) => {
	return (
		<SystemPage
			Service={CriteriaService}
			type={"RatingCriteria"}
			meta={"Criterias "}
			placeholder={"criteria"}
			searchPlaceholder={"Search by Rating name"}
			header={"Rating Criterias"}
			hasSub={false}
		/>
	);
};

export default CriteriasPage;
